import axios from "../../../utils/authAxios";
const api_base_url = process.env.REACT_APP_API_BASEURL;

export const getPaymentRemittanceType = async () => {
  const { data } = await axios.get(
    `${api_base_url}/PaymentRemittanceType/AgreementPaymentRemittanceType`);
  return data;
};

export const deletePaymentRemittanceType = async (ids) => {
  await axios.delete(`${api_base_url}/PaymentRemittanceType`, {
    data: ids,
  });
};

export const addPaymentRemittanceType = async (newPaymentRemittanceType) => {
  const { data }  = await axios.post(`${api_base_url}/PaymentRemittanceType`,
    newPaymentRemittanceType);
  return data;
};

export const updatePaymentRemittanceType = async (
  editPaymentRemittanceType
) => {
  const formData = new FormData();
  editPaymentRemittanceType.paymentRemittanceTypeId &&
    formData.append(
      "paymentRemittanceTypeId",
      editPaymentRemittanceType.paymentRemittanceTypeId
    );
  editPaymentRemittanceType.paymentRemittanceTypeName &&
    formData.append("paymentRemittanceTypeName",
    editPaymentRemittanceType.paymentRemittanceTypeName
    );
  editPaymentRemittanceType.createdBy &&
    formData.append("CreatedBy", editPaymentRemittanceType.createdBy);
  editPaymentRemittanceType.createdDate &&
    formData.append("CreatedDate", editPaymentRemittanceType.createdDate);
  editPaymentRemittanceType.modifiedBy &&
    formData.append("ModifiedBy", editPaymentRemittanceType.modifiedBy);
  editPaymentRemittanceType.modifiedDate &&
    formData.append("ModifiedDate", editPaymentRemittanceType.modifiedDate);
  editPaymentRemittanceType.status &&
    formData.append("Status", editPaymentRemittanceType.status);
  return axios.put(`${api_base_url}/PaymentRemittanceType/`, formData);
};